import "./App.css";
import { useState } from "react";
import Weather from "./Weather";
import Author from "./Author";
import axios from "axios";
import Convertion from "./Conversion";
import Loader from "react-js-loader";

export default function App() {
  let [city, setCity] = useState("Lisbon");
  let [weatherData, setWeatherData] = useState({ loaded: false });
  let [firstApiCall, setFirstApiCall] = useState(false);

  function updateData(response) {
    setWeatherData({
      loaded: true,
      city: response.data.name,
      temperature: response.data.main.temp,
      humidity: response.data.main.humidity,
      wind: response.data.wind.speed,
      description: response.data.weather[0].description,
      date: new Date(response.data.dt * 1000),
      icon: response.data.weather[0].icon,
      coord: response.data.coord,
    });
  }

  function makeApiCall() {
    setFirstApiCall(true);
    // it calls makeApiCall() two times when loading
    let apiKey = "e8e93f578b2129732547ba981f082a81";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(updateData);
  }

  function handlecityChange(event) {
    setCity(event.target.value);
  }

  function handleSubmit(event) {
    event.preventDefault();
    makeApiCall();
  }

  let submit = (
    <div className="submit">
      <form className="Form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Enter a city"
          className="citySubmit"
          onChange={handlecityChange}
        />
        <button>
          <i className="fas fa-search"></i>
        </button>
      </form>
      <Convertion />
    </div>
  );

  let notLoaded = (
    <div className="App container">
      <div className="weather-app">
        {submit}
        <div className="loader">
          <Loader type="bubble-scale" bgColor={"rgb(21, 54, 133)"} size={70} />
        </div>
      </div>
      <Author />
    </div>
  );

  if (weatherData.loaded && firstApiCall) {
    return (
      <div className="App container">
        <div className="weather-app">
          {submit}
          <Weather data={weatherData} />
        </div>
        <Author />
      </div>
    );
  } else if (firstApiCall) {
    return notLoaded;
  } else {
    makeApiCall();
    return notLoaded;
  }
}
